"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BackgroundEnum;
(function (BackgroundEnum) {
    // Default initial assets
    BackgroundEnum["LOGIN"] = "assets:backgrounds/login.png";
    BackgroundEnum["OCEAN"] = "assets:backgrounds/ocean.svg";
    BackgroundEnum["WAVES"] = "assets:backgrounds/waves.svg";
    BackgroundEnum["PURPLE_PINWHEEL"] = "assets:backgrounds/purple-pinwheel.svg";
    // K-5
    BackgroundEnum["DARK_GALAXY"] = "assets:backgrounds/dark-galaxy.svg";
    BackgroundEnum["SUNNY_GALAXY"] = "assets:backgrounds/sunny-galaxy.svg";
    BackgroundEnum["SUNSPOT_GALAXY"] = "assets:backgrounds/sunspot-galaxy.svg";
    BackgroundEnum["SUNSET"] = "assets:backgrounds/sunset.svg";
    BackgroundEnum["BLUE_SKY"] = "assets:backgrounds/blue-sky.svg";
    BackgroundEnum["DESERT"] = "assets:backgrounds/desert.svg";
    BackgroundEnum["BLUE_SEA"] = "assets:backgrounds/blue-sea.svg";
    BackgroundEnum["DEEP_DIVE"] = "assets:backgrounds/deep-dive.svg";
    BackgroundEnum["SUNSET_HILLS"] = "assets:backgrounds/sunset-hills.svg";
    BackgroundEnum["HAPPY_HILLS"] = "assets:backgrounds/happy-hills.svg";
    BackgroundEnum["FOREST"] = "assets:backgrounds/forest.svg";
    BackgroundEnum["SPACE_ODYSSEY"] = "assets:backgrounds/space-odyssey.svg";
    BackgroundEnum["MOUNTAINSK5"] = "assets:backgrounds/mountains-k5.svg";
    BackgroundEnum["CRIMSON_SPACE"] = "assets:backgrounds/crimson-space.svg";
    BackgroundEnum["SPACE_DESERT"] = "assets:backgrounds/space-desert.svg";
    BackgroundEnum["WATERFALLS"] = "assets:backgrounds/waterfalls.svg";
    BackgroundEnum["MOUNTAINSIDE"] = "assets:backgrounds/mountainside.svg";
    BackgroundEnum["DESERT_FLOWER"] = "assets:backgrounds/desert-flower.svg";
    BackgroundEnum["MOUNTAIN_LAKE"] = "assets:backgrounds/mountain-lake.svg";
    BackgroundEnum["NIGHT_SKY"] = "assets:backgrounds/night-sky.svg";
    BackgroundEnum["SEA_PLANTS"] = "assets:backgrounds/sea-plants.svg";
    // 6-8
    BackgroundEnum["MOUNTAIN_FALLS"] = "assets:backgrounds/mountain-falls.jpg";
    BackgroundEnum["COSMOS"] = "assets:backgrounds/cosmos.png";
    BackgroundEnum["WAVE"] = "assets:backgrounds/wave.png";
    BackgroundEnum["CACTI"] = "assets:backgrounds/cacti.png";
    BackgroundEnum["WATER"] = "assets:backgrounds/water.png";
    BackgroundEnum["JELLYFISH"] = "assets:backgrounds/jellyfish.png";
    BackgroundEnum["PINK_PATTERN"] = "assets:backgrounds/pink-pattern.png";
    BackgroundEnum["DOG"] = "assets:backgrounds/dog.png";
    BackgroundEnum["PANDA"] = "assets:backgrounds/panda.png";
    BackgroundEnum["COOL_CAT"] = "assets:backgrounds/cool-cat.png";
    BackgroundEnum["HAPPY_PUPPY68"] = "assets:backgrounds/happy-puppy-68.jpg";
    BackgroundEnum["AMUSEMENT"] = "assets:backgrounds/amusement.jpg";
    BackgroundEnum["SPACE_KITTY"] = "assets:backgrounds/space-kitty.jpg";
    BackgroundEnum["THINKING_MONKEY"] = "assets:backgrounds/thinking-monkey.jpg";
    BackgroundEnum["FISH_PARTY"] = "assets:backgrounds/fish-party.jpg";
    // 9-12
    BackgroundEnum["PURPLE_PATTERN"] = "assets:backgrounds/purple-pattern.svg";
    BackgroundEnum["BIG_WAVE"] = "assets:backgrounds/big-wave.jpg";
    BackgroundEnum["BRIGHT_SWATCHES"] = "assets:backgrounds/bright-swatches.jpg";
    BackgroundEnum["DEEP_SPACE"] = "assets:backgrounds/deep-space.jpg";
    BackgroundEnum["HAPPY_PUPPY"] = "assets:backgrounds/happy-puppy.jpg";
    BackgroundEnum["LEAVES"] = "assets:backgrounds/leaves.jpg";
    BackgroundEnum["NAP_TIME"] = "assets:backgrounds/nap-time.jpg";
    BackgroundEnum["SPACE_LIGHT"] = "assets:backgrounds/space-light.jpg";
    BackgroundEnum["SUNNY_STREAM"] = "assets:backgrounds/sunny-stream.jpg";
    BackgroundEnum["WATERFALL"] = "assets:backgrounds/waterfall.jpg";
    BackgroundEnum["MOUNTAINS"] = "assets:backgrounds/mountains.jpg";
    BackgroundEnum["SEA_CORAL"] = "assets:backgrounds/sea-coral.jpg";
    BackgroundEnum["DESERT_SUNSET"] = "assets:backgrounds/desert-sunset.jpg";
    BackgroundEnum["TROPICS"] = "assets:backgrounds/tropics.jpg";
    BackgroundEnum["MACHU_PICCHU"] = "assets:backgrounds/machu-picchu.jpg";
    BackgroundEnum["PYRAMIDS"] = "assets:backgrounds/pyramids.jpg";
    BackgroundEnum["SPIDER_WEB"] = "assets:backgrounds/spider-web.jpg";
    BackgroundEnum["ANCIENT_RUINS"] = "assets:backgrounds/ancient-ruins.jpg";
    BackgroundEnum["HORSESHOE_BEND"] = "assets:backgrounds/horseshoe-bend.jpg";
    BackgroundEnum["WHALE_SUNSET"] = "assets:backgrounds/whale-sunset.jpg";
    // AMUSEMENT shared from 6-8
    // Visual Action Backgrounds
    BackgroundEnum["ENGLISH"] = "assets:backgrounds/reading.png";
    BackgroundEnum["READING"] = "assets:backgrounds/reading.png";
    BackgroundEnum["MATH"] = "assets:backgrounds/math.png";
    // Theme specific
    BackgroundEnum["DEFAULT"] = "theme:backgrounds/default.svg";
    BackgroundEnum["PRIMARY"] = "theme:backgrounds/primary.svg";
})(BackgroundEnum || (BackgroundEnum = {}));
exports.default = BackgroundEnum;
